import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalStateService } from '../global/global-state.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private service_type = "invoices"
  public baseURL = '';

  constructor(private _globalStateService: GlobalStateService, private _http: HttpClient) {
    this.baseURL = this._globalStateService.GetBaseEndpoint('base');
  }

  GetData(page_number: string, search: string = '',filters:Record<string,any>={}): Observable<any> {

    let params = new URLSearchParams(filters).toString();
    const url = `${this.baseURL}/${this.service_type}?page=${page_number}&search=${search}&${params}`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  GetDataById(id: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  DeleteDataById(id: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.delete<any>(url);
  }

  AddData(data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}`; // Replace with your API endpoint
    return this._http.post<any>(url, data);
  }

  UpdateData(id: string, data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.patch<any>(url, data);
  }

  UpdateDataValue(data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/bulk/update`; // Replace with your API endpoint
    return this._http.patch<any>(url, data);
  }

  SendMail(data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/send-mail`; // Replace with your API endpoint
    return this._http.post<any>(url, data);
  }

  bulkUpdateCommission(data: Array<{ invoice_id: string; sales_commission?: number; sales_commission_date?: string }>): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/bulk/update`;
    return this._http.patch<any>(url, { data });
  }

  exportCommissionExcel(filters: Record<string, any> = {}): Observable<Blob> {
    let params = new URLSearchParams(filters).toString();
    const url = `${this.baseURL}/${this.service_type}/export/commission?${params}`;
    return this._http.get(url, { responseType: 'blob' });
  }

}
